import React, { Component } from "react";
import { StyleSheet, KeyboardAvoidingView } from "react-native";
import Text from "../components_v2/TextFont";

import ArTheme from "../argon-ui/Theme";
import InputBase from "../nativeBase-ui/InputBase";
import Select from "../nativeBase-ui/Select";
import { HStack } from "native-base";
import Theme from "../argon-ui/Theme";
import { getIsRTL } from "../util";

const H_INPUT = 40;
export type propTypes = {
  protocols?: string[];
  protocol?: "http" | "https" | string;
  domain?: string;
  port?: number;
  url?: string;
  tailing?: string;
  label?: string;
  onChange: (
    url: string,
    uriParts: { protocol: string; domain: string; port: number }
  ) => void;
};

export type state = {
  protocols: string[];
  protocol: string;
  domain: string;
  port: number | null;
};

class UrlPicker extends Component<propTypes, state> {
  constructor(props: propTypes) {
    super(props);
    let { protocols, protocol, domain, port, url } = this.props;
    if (url) {
      var parts = url.split("://");
      if (parts.length > 1) {
        protocol = parts[0];
        var secondParts = parts[1].split(":");
        domain = secondParts[0];
        port = Number(secondParts[1]) || protocol == "https" ? 443 : 80;
      }
    }
    this.state = {
      protocols: protocols || ["http", "https"],
      protocol: protocol || "http",
      domain: domain || "",
      port: port || 80,
    };
  }

  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    if (nextProps.port != prevState.port && prevState.port == 0)
      return { ...prevState, port: nextProps.port };
  }

  handleOnChange = () => {
    let { protocol, domain, port } = this.state;
    var url = `${protocol}://${domain}`;
    if (port) url += `:${port || ""}`;
    if (this.props.tailing) url += this.props.tailing;
    typeof this.props.onChange === "function" &&
      this.props.onChange(url, { protocol, domain, port: port || 0 });
  };

  render(): React.ReactNode {
    return (
      <KeyboardAvoidingView style={[styles.container, styles.shadow]}>
        {this.props.label != undefined && (
          <Text
            style={{
              color: Theme.COLORS.GRAY_DARK,
              fontSize: 14,
            }}
          >
            {this.props.label}
          </Text>
        )}
        <HStack
          space="1"
          w="100%"
          alignItems="center"
          justifyContent="space-between"
          flexDirection={getIsRTL() ? "row" : "row-reverse"}
        >
          {/* === Port === */}
          <InputBase
            keyboardType="numeric"
            containerStyle={{ width: 55, height: H_INPUT }}
            inputStyle={{ textAlign: "left" }}
            value={(this.props.port || "").toString()}
            placeholder=""
            onChangeText={(text: string) =>
              this.setState({ port: Number(text) || null }, this.handleOnChange)
            }
          />
          <Text style={{ fontSize: 18 }}>:</Text>
          {/* === Domain Name === */}
          <InputBase
            containerStyle={{ flex: 2.5, height: H_INPUT }}
            inputStyle={{ textAlign: "left", fontSize: 12 }}
            placeholder="192.168...."
            onChangeText={(text: string) =>
              this.setState({ domain: text || "" }, this.handleOnChange)
            }
            value={this.props.domain}
            // isInvalid={formValidityData.codeLetterError}
          />
          {/* === Scheme (http:// | https://) === */}
          <Select
            data={this.state.protocols.map((p) => {
              return {
                label: p,
                value: p,
              };
            })}
            value={this.props.protocol}
            onChangeText={(value: string) => {
              this.setState({ protocol: value }, this.handleOnChange);
            }}
            style={{
              height: H_INPUT,
              width: 40,
              textAlign: "left",
              direction: "ltr",
              fontSize: 10,
            }}
            containerStyle={{ flex: 1.5, width: 40, maxWidth: 100 }}
            //   placeholder={SCHEME[0]}
          />
        </HStack>
      </KeyboardAvoidingView>
    );
  }
}

const styles = StyleSheet.create({
  row: { flexDirection: getIsRTL() ? "row-reverse" : "row" },
  input: {
    backgroundColor: ArTheme.COLORS.WHITE,
    borderColor: ArTheme.COLORS.BORDER_COLOR,
    borderWidth: 1,
    borderRadius: 5,
    flex: 1,
    height: 44,
    marginHorizontal: 10,
  },
  shadow: {
    shadowColor: ArTheme.COLORS.BLACK,
    shadowOffset: { width: 0, height: 1 },
    shadowRadius: 2,
    shadowOpacity: 0.05,
    elevation: 2,
  },
  container: {
    width: "100%",
    backgroundColor: ArTheme.COLORS.WHITE,
    paddingHorizontal: 10,
    paddingTop: 10,
    marginTop: 10,
    marginHorizontal: 1,
    borderRadius: 5,
  },
});

export default UrlPicker;
